module.exports = __webpack_public_path__ + "static/media/angelo_profile.0fdc8abe.jpg";